module.exports = __webpack_public_path__ + "img/fringe-5in-bullion.5a00dd04.png";